import type { ModuleRoute } from '../types';
import { registerSettingsCard } from '../../components/SettingsCards';
import { NotificationSettingsCard } from './NotificationCards';
import { NotificationsPage } from './NotificationsPage';
import { RuleEditorPage } from './RuleEditor';
import { WebhookCreatePage, WebhookDetailPage, WebhooksPage } from './WebhookPages';

// The site page's "Reception contacts" card and the group page's "Notifications" card.
registerSettingsCard('notifications', NotificationSettingsCard);

/** Pages of this area (notification rules, delivery log, webhooks). Owned by Phase 2 task W10; only that task edits files in this folder. */
export const routes: ModuleRoute[] = [
  { path: '/manage/notifications', element: <NotificationsPage />, permission: 'notifications.view' },
  { path: '/manage/notifications/new', element: <RuleEditorPage />, permission: 'notifications.manage' },
  { path: '/manage/notifications/:id', element: <RuleEditorPage />, permission: 'notifications.manage' },
  { path: '/manage/webhooks', element: <WebhooksPage />, permission: 'webhooks.view' },
  { path: '/manage/webhooks/new', element: <WebhookCreatePage />, permission: 'webhooks.manage' },
  { path: '/manage/webhooks/:id', element: <WebhookDetailPage />, permission: 'webhooks.view' },
];
